import { Modal, Select, Tabs } from "antd";
import { useEffect, useState } from "react";
import {
  addFreeLicense,
  retrieveCameraList,
  retrieveFreeGoods,
  retrieveSiteList,
} from "./service";
import { showToast } from "ui/components/common";

export default function FreeLicense({ user, onClose, visible }) {
  const [activeTab, setActiveTab] = useState("customer");
  const [freeGoodsList, setFreeGoodsList] = useState([]);
  const [goodsId, setGoodsId] = useState(null);
  const [siteList, setSiteList] = useState([]);
  const [siteId, setSiteId] = useState(null);
  const [cameraList, setCameraList] = useState([]);
  const [cameraId, setCameraId] = useState(null);
  useEffect(() => {
    if (!visible) {
      setActiveTab("customer");
      setGoodsId(null);
      setSiteId(null);
      setCameraId(null);
    }
  }, [visible]);
  useEffect(() => {
    retrieveFreeGoods().then((data) => {
      if (data.status !== 200) {
        showToast(1, "Failed to get free goods list, please try again later");
        return;
      }
      setFreeGoodsList(
        data.data?.goodsInfos?.map((good) => ({
          label: good.name,
          value: good.goodsId,
        })) || [],
      );
    });
  }, []);
  useEffect(() => {
    if (activeTab !== "site" && activeTab !== "camera") return;
    if (!user) return;
    setSiteList([]);
    setSiteId(null);
    retrieveSiteList(user.organization.id).then((data) => {
      if (data.status !== 200) {
        showToast(1, "Failed to get site list, please try again later");
        return;
      }
      setSiteList(
        data.data?.sites?.map((site) => ({
          label: site.name,
          value: site.id,
        })) || [],
      );
    });
  }, [user, activeTab]);
  useEffect(() => {
    if (activeTab !== "camera") return;
    if (!siteId || !user) return;
    setCameraList([]);
    setCameraId(null);
    retrieveCameraList(siteId, user.organization.id).then((data) => {
      if (data.status !== 200) {
        showToast(1, "Failed to get camera list, please try again later");
        return;
      }
      setCameraList(
        data.data?.data?.map((camera) => ({
          label: camera.name,
          value: camera.id,
        })) || [],
      );
    });
  }, [siteId, activeTab, user]);
  async function onSave() {
    if (!goodsId) return showToast(1, "Please select goods");
    let _cameraId = cameraId;
    let _siteId = siteId;
    if (activeTab === "customer") {
      _cameraId = undefined;
      _siteId = undefined;
    } else if (activeTab === "site") {
      if (!siteId) return showToast(1, "Please select site");
      _cameraId = undefined;
    } else {
      if (!siteId) return showToast(1, "Please select site");
      if (!cameraId) return showToast(1, "Please select camera");
    }
    const res = await addFreeLicense({
      cameraIds: _cameraId && [_cameraId],
      goodsId,
      orgId: user.organization.id,
      siteIds: _siteId && [_siteId],
    });
    if (res.status !== 200) {
      showToast(1, "Failed to add free license");
      return;
    } else {
      if (res.data.failedCameraIds?.length) {
        showToast(1, "Failed cameraIds : " + res.data.failedCameraIds);
      } else {
        showToast(0, "Successfully added free license");
        onClose();
      }
    }
  }
  return (
    <Modal
      onCancel={onClose}
      open={visible}
      okButtonProps={{ className: "primaryButton" }}
      onOk={onSave}
      okText="Confrim"
      cancelButtonProps={{ className: "primaryButton bordered" }}
    >
      <Tabs
        tabPosition="top"
        activeKey={activeTab}
        onChange={setActiveTab}
        items={[
          { label: "To Customer", key: "customer" },
          { label: "To Site", key: "site" },
          { label: "To Camera", key: "camera" },
        ]}
      />
      <div>
        <Select
          options={freeGoodsList}
          value={goodsId}
          onChange={(value) => {
            setGoodsId(value);
          }}
          style={{ width: "200px", marginTop: "10px" }}
          placeholder={"Select Goods"}
        />
      </div>
      {(activeTab === "site" || activeTab === "camera") && (
        <div>
          <Select
            options={siteList}
            value={siteId}
            onChange={(value) => {
              setSiteId(value);
            }}
            style={{ width: "200px", marginTop: "10px" }}
            placeholder={"Select Site"}
          />
        </div>
      )}
      {activeTab === "camera" && (
        <div>
          <Select
            options={cameraList}
            value={cameraId}
            onChange={(value) => {
              setCameraId(value);
            }}
            style={{ width: "200px", marginTop: "10px" }}
            placeholder={"Select Camera"}
          />
        </div>
      )}
    </Modal>
  );
}
